export default __webpack_public_path__ + "static/media/param.71928cca.png";